export class FichaExpediente {
    nfichaexpedienteId: number;
    nfichaexpedienteIdtipd: number;
    cfichaexpedienteCodtipo: string;
    cfichaexpedienteNumExp: string;
    nfichaexpedienteAnio: string;
    nfichaexpedienteTipExp: string; // SGD, OCI

}

